import { FundingDirection, FundingStage } from '@app/codegen';

import { AccountsRoutes } from './Accounts/AccountsRoutes';
import { AdminRoutes } from './Admin/AdminRoutes';
import { CustomerRoutes } from './Customers/CustomersRoutes';
import { FundingsInflowRoutes } from './FundingsInflow/FundingsInflowRoutes';
import { FundingsOutflowRoutes } from './FundingsOutflow/FundingsOutflowRoutes';
import { StakingRoutes } from './Staking/StakingRoutes';

export const MainDrawerRoutes = {
	MainDrawerNavigation: {
		path: 'main',
		screens: {
			...AccountsRoutes,
			...CustomerRoutes,
			...FundingsInflowRoutes,
			...FundingsOutflowRoutes,
			...AdminRoutes,
			...StakingRoutes,
		},
	},
};

export type EditFundingScreenParams = {
	fundingId: number;
	fundingStage?: FundingStage;
	direction: FundingDirection;
};

export type MainDrawerParams = keyof typeof MainDrawerRoutes.MainDrawerNavigation.screens;

export type MainDrawerParamsRecord = Record<MainDrawerParams, undefined>;
